import styled from 'styled-components';

export const Container = styled.div`
  padding: 16px;
`;

export const Alerta = styled.div`
  margin-bottom: 16px;
  padding: 10px 14px;
  border: 1px solid ${({ theme }) => theme.warningColor};
  border-left-width: 4px;
  border-radius: 8px;
  font-size: 13px;
  color: ${({ theme }) => theme.textColor};
  background-color: ${({ theme }) =>
    theme.isDark ? 'rgba(230, 81, 0, 0.15)' : '#fff8e1'};

  strong {
    display: block;
    margin-bottom: 4px;
    color: ${({ theme }) => theme.warningColor};
  }

  ul {
    margin: 0;
    padding-left: 18px;
  }
`;

export const Erro = styled.div`
  margin-bottom: 16px;
  padding: 10px 14px;
  border: 1px solid ${({ theme }) => theme.dangerColor};
  border-left-width: 4px;
  border-radius: 8px;
  font-size: 13px;
  color: ${({ theme }) => theme.dangerColor};
  background-color: ${({ theme }) =>
    theme.isDark ? 'rgba(197, 48, 48, 0.15)' : theme.dangerLightColor};
`;

export const SemCarga = styled.span`
  display: inline-block;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  color: ${({ theme }) => theme.white};
  background-color: ${({ theme }) => theme.darkGray};
`;

export const Pendencia = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.warningColor};
`;

export const CampoData = styled.div`
  min-width: 220px;
`;
